/**
 * Polygone approximé du périmètre urbain d'Istres (Bouches-du-Rhône, 13800).
 * Utilisé pour créer un effet "spotlight" sur la carte (le reste du monde assombri).
 * Coordonnées ordonnées [lat, lng] - sens horaire suffisant pour Leaflet polygons.
 */
export const ISTRES_BOUNDARY = [
  [43.5710, 4.9520],
  [43.5680, 5.0050],
  [43.5500, 5.0420],
  [43.5210, 5.0510],
  [43.4920, 5.0410],
  [43.4790, 5.0150],
  [43.4720, 4.9850],
  [43.4760, 4.9520],
  [43.4920, 4.9270],
  [43.5120, 4.9180],
  [43.5380, 4.9210],
  [43.5580, 4.9320],
  [43.5710, 4.9520],
];

/**
 * Polygone du monde — utilisé avec ISTRES_BOUNDARY pour créer un mask
 * (Leaflet polygon avec deux anneaux : extérieur = monde, intérieur = Istres → trou).
 */
export const WORLD_BOUNDARY = [
  [85, -180],
  [85, 180],
  [-85, 180],
  [-85, -180],
  [85, -180],
];
